import { render, staticRenderFns } from "./personprogress.vue?vue&type=template&id=3ea71950&scoped=true&lang=pug&"
import script from "./personprogress.vue?vue&type=script&lang=js&"
export * from "./personprogress.vue?vue&type=script&lang=js&"
import style0 from "./personprogress.vue?vue&type=style&index=0&id=3ea71950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea71950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea71950')) {
      api.createRecord('3ea71950', component.options)
    } else {
      api.reload('3ea71950', component.options)
    }
    module.hot.accept("./personprogress.vue?vue&type=template&id=3ea71950&scoped=true&lang=pug&", function () {
      api.rerender('3ea71950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/personprogress/personprogress.vue"
export default component.exports